import { useEffect } from "react"
import { useLocation, matchPath } from "react-router-dom"
import { useAppDispatch } from "../../store/hooks"
import { aiAssistInit } from "../../store/wpAiConfig/thunks"
import { AiAssistRedirectGuardProps } from "./AiAssistRedirectGuard.types"

export const AiAssistRedirectGuard = ({ children, isAuthorized }: AiAssistRedirectGuardProps) => {
    const dispatch = useAppDispatch()
    const location = useLocation()

    const isUrlSatisfied = () => {
        const pathname = location.pathname

        const indexUrlMatch = matchPath(pathname, {
            path: "/",
            exact: true
        })

        const loginUrlMatch = matchPath(pathname, {
            path: "/login",
            exact: true
        })

        return Boolean(indexUrlMatch || loginUrlMatch)
    }

    useEffect(() => {
        if (isAuthorized && isUrlSatisfied()) {
            dispatch(aiAssistInit())
        }
    }, [dispatch, isAuthorized])

    return <>{children}</>
}
